// extracted by mini-css-extract-plugin
export var bestValueWrapper = "BestValueContainer_bestValueWrapper__rZZHQ";